<div class="multi-select__input">
  <form [formGroup]="form" autocomplete="off">
    <mat-form-field title="Gruppenavn">
      <mat-label>Gruppenavn</mat-label>
      <input matInput formControlName="name" />
    </mat-form-field>

    @if (!editMode) {
      <button mat-flat-button color="primary" title="Tilføj" (click)="submit()" class="add-button" [disabled]="form.invalid">
        <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#plus-s"></use></svg>
      </button>
    }
    @if (editMode) {
      <button mat-flat-button color="primary" title="Gem" (click)="submit()" class="add-button" [disabled]="form.invalid">
        <mat-icon>save</mat-icon>
      </button>
    }
  </form>
  @if (name.invalid && (name.dirty || name.touched)) {
    <mat-error>
      @if (name.hasError('pattern')) {
        <div>Navn må ikke kun indeholde mellemrum</div>
      }
      @if (name.hasError('maxlength')) {
        <div>Navn må maksimalt være {{ name.errors?.['maxlength']?.requiredLength }} tegn</div>
      }
    </mat-error>
  }
</div>
